export enum ExportPdfRangeType {
  CurrentRange = 1,
  AllRange = 2,
  SelectRange = 3,
}
